// core libs
import React from 'react';
import Promise from 'promise';
import $ from 'jquery';

// import SiteDownloads from '../common/SiteDownloads';
import LocationMap from './elements/LocationMap';

import Messenger from './../common/Messenger';
import PageLoading      from '../PageLoading';
let messenger = new Messenger();

// import styles
import '../App.css';
import './location.css';

var sources = require('../config.json');
var styles = require('../googlemapstyles.json');

window.markers = [];

class Location extends React.Component {
	constructor(props) {
		super(props);

		this.location_url = sources.location;
		this.reset_level = sources.mapresetlevel;
		let mapCenter = { lat: sources.mapcenterlat, lng: sources.mapcenterlong };

		this.state = {
			mapCenter: mapCenter,
			masterList: [],
			renderList: [],
			markerGroups: [],
			markerIcons: [],
			renderedMarkers: [],
			markerPopupIsVisible: false,
			selectedMarker: undefined,
			mapConfig: {
				zoom: this.reset_level,
				center: mapCenter,
				disableDefaultUI: true,
				zoomControl: true,
				scrollwheel:false,
				styles:styles
			},
			masterplanOverlay: {},
			markerIconConfig: {},

		};

		this.onDataLoaded = this.onDataLoaded.bind(this);
		this.storeState = this.storeState.bind(this);
		this.setMarkerPopupState = this.setMarkerPopupState.bind(this);
		this.selectRenderList = this.selectRenderList.bind(this);
		this.onCategoryChange = this.onCategoryChange.bind(this);
		this.onMarkerClicked = this.onMarkerClicked.bind(this);
		this.markerFactory = this.markerFactory.bind(this);
		this.getIconConfig = this.getIconConfig.bind(this);
	}

	componentDidMount() {
		$.ajax({url:this.location_url,dataType:'json'}).done(this.onDataLoaded);
	}

	onDataLoaded(data) {
		//console.log(data);
		this.storeState({
			masterList: data.markers,
			renderList: data.markers,
			markerGroups: data.markerGroups,
			masterplanOverlay: data.map,
			markerIconConfig: data.markerIcons
		});
	}

	storeState(updateObject) {
		// console.log(updateObject);
		let newState = Object.assign(this.state, updateObject);
		this.setState(newState);
	}

	selectRenderList() {
		let renderList = [];

		if(this.state.renderList.length > 0) {
			renderList = this.state.renderList;
		} else {
			renderList = this.state.masterList;
		}

		return renderList;
	}

	onRenderMarkers(markers, map) {
		//console.log(markers);
		let bounds = new window.google.maps.LatLngBounds();
		bounds.extend(this.state.mapCenter);

		let mapMarkers = markers.map((markerDetails) => {
			let markerObj = this.markerFactory(markerDetails, map, this.onMarkerClicked.call(this, markerDetails));
			bounds.extend(markerObj.position);
			return markerObj;
		});

		if(mapMarkers.length > 0) {
			map.fitBounds(bounds);
		}

		this.storeState({
			renderedMarkers: mapMarkers
		});
	}

	markerFactory(markerDetails, mapReference, onClickHandler) {
		let markerObject = new window.google.maps.Marker({
			position: { lat: markerDetails.latitude, lng: markerDetails.longtitude },
			map: mapReference,
			icon: this.getIconConfig(markerDetails.image, markerDetails.markerGroupId)
		});

		// console.log(markerDetails.image);
		// console.log(markerObject);

		markerObject.addListener('click', onClickHandler);
		markerObject.mTag = markerDetails.title;

		window.markers.push(markerObject);
		return markerObject;
	}

	getIconConfig(markericon,markergroup) {
		let marker = {};
		var markers = this.state.markerIconConfig;

		if (markericon) {
			let markerID = markers.reduce((accum, curr, index) => {
				if(curr.groupid === markergroup) {
					accum = index;
				}
				return accum;
			}, null);

			marker = {
				url: markericon,
				size: new window.google.maps.Size(markers[markerID].sx, markers[markerID].sy),
				origin: new window.google.maps.Point(markers[markerID].ox, markers[markerID].oy),
				anchor: new window.google.maps.Point(markers[markerID].ax, markers[markerID].ay),
				scaledSize: new window.google.maps.Size(markers[markerID].ssx, markers[markerID].ssy)
			};
		}
		return(marker);
	}

	onMarkerClicked(markerDetails) {
		return function () {
			// console.log('marker clicked');
			Promise.all([
				requestAndRenderDirections(this.state.mapCenter, markerDetails, window.google.maps.TravelMode['DRIVING'], this.googleMap.directionService),
				requestAndRenderDirections(this.state.mapCenter, markerDetails, window.google.maps.TravelMode['BICYCLING'], this.googleMap.directionService)
			]).then(function (responses) {
				// console.log('promise response');
				if(this.googleMap.directionsDisplay) {
					// console.log('reset directionsDisplay');
					this.googleMap.directionsDisplay.setMap(null);

					// console.log('create new directionsrenderer');
					this.googleMap.directionsDisplay = new window.google.maps.DirectionsRenderer({
						suppressMarkers: true
					});

					// console.log('set map on directionsrenderer');
					this.googleMap.directionsDisplay.setMap(this.googleMap.mapReference);
				} else {
					// console.log('create new directionsdisplay in else');
					this.googleMap.directionsDisplay = new window.google.maps.DirectionsRenderer({
						suppressMarkers: true
					});

					// console.log('set map in else');
					this.googleMap.directionsDisplay.setMap(this.googleMap.mapReference);
				}

				// console.log('set directions');
				this.googleMap.directionsDisplay.setDirections(responses[0]);

				// console.log('create timeout');
				setTimeout(function () {
					// console.log('firing set timeout');
					let elem = document.getElementById('super-awesome-show-me');
					// console.log(elem);
					elem.classList.add('visible');

					messenger.publish('send-data-to-box', {
						markerObject: markerDetails,
						directionsResponse: responses
					});
				}, 250);

				// console.log('store state');
				this.storeState({
					markerPopupIsVisible: true,
					selectedMarker: {
						markerObject: markerDetails,
						directionsResponse: {
							carResponse: responses[0],
							bikeResponse: responses[1]
						}
					}
				});

				// console.log('after store state');
			}.bind(this));
		}.bind(this);
	}

	onMarkerPopupClose() {
		if(this.googleMap) {
			this.googleMap.directionsDisplay.setMap(null);
		}

		let bounds = new window.google.maps.LatLngBounds();
		bounds.extend(this.state.mapCenter);
		this.state.renderedMarkers.forEach(function (marker) {
			bounds.extend(marker.position);
		});

		this.googleMap.mapReference.fitBounds(bounds);

		this.storeState({
			markerPopupIsVisible: false,
			selectedMarker: undefined
		});

		setTimeout(function () {
			// console.log('firing set timeout');
			let elem = document.getElementById('super-awesome-show-me');
			// console.log(elem);
			elem.classList.remove('visible');
		}, 250);
	}

	setMarkerPopupState(markerVisibilityState) {
		return function () {
			this.storeState({
				markerPopupIsVisible: markerVisibilityState
			});
		}.bind(this);
	}

	onCategoryReset(selectedCategory) {
		//close the popup
		this.onMarkerPopupClose();

		//calling setMap(null) on markers removes them
		for(let j = 0; j < window.markers.length; j++) {
			window.markers[j].setMap(null);
		}

		//reset the global marker reference buffer
		window.markers = [];

		if(this.googleMap) {
			//if we have a reference to the locationMap, set directions display to none to remove it
			this.googleMap.directionsDisplay.setMap(null);
			this.googleMap.mapReference.setZoom(this.reset_level);
			this.googleMap.mapReference.setCenter(this.state.mapCenter);
		}

		this.storeState({
			renderedMarkers: window.markers, //empty array
			renderList: [], //no markers should be rendered
			markerPopupIsVisible: false, //popup is not visible
			selectedMarker: undefined //undefine selected marker
		});
	}

	onCategoryChange(selectedCategory) {
		this.onMarkerPopupClose();
		for(let j = 0; j < window.markers.length; j++) {
			window.markers[j].setMap(null);
		}

		window.markers = [];

		if(this.googleMap) {
			this.googleMap.directionsDisplay.setMap(null);
		}

		let renderList = this.state.masterList.filter(
			(marker) => marker.markerGroupId === selectedCategory
		);

		if(renderList.length === 0) {
			renderList = this.state.masterList;
		}

		this.storeState({
			renderedMarkers: window.markers,
			renderList: renderList,
			markerPopupIsVisible: false,
			selectedMarker: undefined
		});

		this.onRenderMarkers(renderList, this.googleMap.mapReference);
	}

	render() {
		if(this.state.masterplanOverlay.imageUrl) {
			return (
				<div>
					<div>
						<LocationMap
							ref={(googleMap) => {
								if (googleMap !== null) {
									this.googleMap = googleMap;
								}
							}}
							mapId="location-map"
							apiKey={sources.googlemapsapikey}
							messenger={messenger}
							mapConfig={this.state.mapConfig}
							selectedMarker={this.state.selectedMarker}
							markerPopupIsVisible={this.state.markerPopupIsVisible}
							onMarkerPopupClose={this.onMarkerPopupClose.bind(this)}
							markers={this.selectRenderList()}
							renderedMarkers={this.state.renderedMarkers}
							markerGroups={this.state.markerGroups}
							onRenderMarkers={this.onRenderMarkers.bind(this)}
							onCategoryChange={this.onCategoryChange.bind(this)}
							onCategoryReset={this.onCategoryReset.bind(this)}
							masterplanOverlay={this.state.masterplanOverlay}
							masterplanOverlayRedirect="/land-for-sale"
							params={this.props.params}/>
					</div>
					{/*<SiteDownloads />*/}
				</div>
			);
		} else {
			return (
				<PageLoading>Location Map</PageLoading>
			)
		}
	}
}

function requestAndRenderDirections(origin, markerData, travelMode, directionService) {
	return new Promise(function (resolve, reject) {
		let destination = new window.google.maps.LatLng(markerData.latitude, markerData.longtitude);
		let request = {
			origin: origin,
			destination: destination,
			travelMode: travelMode
		};

		directionService.route(request, function(response, status) {
			if(status === 'OK') {
				resolve(response);
			} else {
				reject();
			}
		});
	});
}

export default Location;


/** WEBPACK FOOTER **
 ** ./src/modules/location/Location.js
 **/